import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    resetFilter,
} from './../../../actions/FilterActions';
import config from './../../../config';
import common from './../../../common';

class FilterError extends Component {
    onResetFilter = () => {
        this.props.resetFilter();
        let pageName = "";
        if (window.location.pathname.indexOf("/manage-team")) {
            pageName = "/uclfantasy/my-team/transfers/"
        } else {
            pageName = "/uclfantasy/create-team/"
        }
        common.customTracking('Reset Filters - No Results', pageName);
    };
    getLastSkill = (highlightedSkill) => {
        const thisHighlightedSkill = highlightedSkill || {};
        const skill = thisHighlightedSkill.skill ? thisHighlightedSkill.skill : config.EnumPosition.Forwards;
        const lastSkill = common.getLocalStorage('lastSkill');
        return (skill || lastSkill);
    };

    render() {
        const lastSkill = this.getLastSkill(this.props.highlightedSkill);
        if (lastSkill) {
            const playerFilters = this.props.playerFilters;
            const teamIDs = playerFilters.teamIds;
            const searchString = playerFilters.searchString;
            const isSearchApplied = searchString.length > 0;



            const isSkillApplied = playerFilters.skillId.length > 0;
            const isPlayerStatusFilterApplied = playerFilters.playerStatus.filter(function (skillObj) {
                if (skillObj.active) {
                    return true;
                } else {
                    return false;
                }
            });

            const isPlayerRecomendationApplied = playerFilters.playerRecomendation[0] != "playerRecomendationdDefault";
            const isFilterApplied = teamIDs.length > 0 || (playerFilters.priceFilterSelected[0] != 100) || isSkillApplied || isPlayerStatusFilterApplied.length || isPlayerRecomendationApplied;
            const searchAndFilterApplied = isSearchApplied && (isFilterApplied || isSkillApplied || isPlayerStatusFilterApplied.length || isPlayerRecomendationApplied);
            let msg = searchAndFilterApplied ? this.props.trans['playerListFilterNoResultMsgWithFilter'] : (isSearchApplied ? this.props.trans['playerListFilterNoResultSearch'].replace('{playerSkill}', this.props.trans[lastSkill]).replace('{searchStr}', searchString) : (isFilterApplied ? this.props.trans['playerListFilterNoResultMsg'] : this.props.trans['playerListNoResultMsg']));
            return (isSearchApplied || isFilterApplied || isSkillApplied || isPlayerStatusFilterApplied.length || isPlayerRecomendationApplied) ? <div className="si-no-data">
                <span className="si-title">{ this.props.trans['playerListFilterNoResult'] }</span>
                <span>{ msg }</span>
                { (isFilterApplied) ? <div className="si-btn"
                    onClick={ () => this.onResetFilter() }>{ this.props.trans['playerListFilterNoResultReset'] }</div> : null }
            </div> : null;
        } else {
            return null;
        }
    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        playerFilters: state.formationData.playerFilters,
        highlightedSkill: state.formationData.teamData.highlightedSkill,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        resetFilter: (bool) => dispatch(resetFilter()),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(FilterError);


// WEBPACK FOOTER //
// ./src/components/onboarding/filters/FilterError.js